import React, { useRef, useState } from "react";

import styled from "styled-components/macro";

import API from "Signups/API";
import { signupItemStateHooks } from "Signups/SignupView/SignupSheet/Screens/SignupItems/stateHooks";
import { useSignups } from "Signups/state";
import { useSignupListID } from "Signups/stateHooks";
import { AnimatePresence, motion } from "framer-motion";

import FnrButton3 from "UI/FnrButton3";
import { FnrPopoverWithScroll } from "UI/FnrPopover2";

export default function UnpaidPill({
  name = "this person",
  signupItemID,
  respondentID,
  additionalNameID,
  unpaidSlotsCount,
  isItemType,
  style,
}) {
  const pillRef = useRef();
  const [, dispatch] = useSignups();
  const { signupListID } = useSignupListID();
  
  const [showPopover, setShowPopover] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const { getSignupItem } = signupItemStateHooks.useGetSignupItem();

  const markAsPaid = () => {
    setLoading(true);
    let payload = {
      userSignupItemsPaymentStatus: "MarkedAsPaid",
      additionalNameID,
    };
    // console.log("payload", payload);
    API.markAsPaid(signupListID, payload)
      .post()
      .then((resp) => {
        setShowPopover(false);
        if (resp?.signupList && resp?.allSignupLists) {
          getSignupItem(signupItemID);
          dispatch({
            type: "Other User Signup Updated",
            signupList: resp.signupList,
            allSignupLists: resp.allSignupLists,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        setError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleClose = () => {
    setShowPopover(false);
    setError(false);
  };

  return (
    <>
      <Pill
        ref={pillRef}
        onClick={() => setShowPopover(true)}
        style={style}
        $hasUnpaidSlots={isItemType && unpaidSlotsCount > 0}
      >
        {isItemType ? `${unpaidSlotsCount} Unpaid` : "Not Paid"}
      </Pill>
      <FnrPopoverWithScroll
        buttonRef={pillRef}
        show={showPopover}
        style={{ maxWidth: "270px" }}
        onShouldClose={handleClose}
        scrollingElClassname=".SignupSheet"
        bgTransparency={1}
      >
        <PopoverContent key="main-content">
          <TheQuestion>
            Would you like to mark <strong>{name}</strong> as paid?
          </TheQuestion>
          <div style={{ marginTop: "10px" }} />

          <AnimatePresence>
            {error ? (
              <Error
                key="error-content"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
              >
                <i
                  className="far fa-exclamation-circle"
                  style={{ marginRight: "5px" }}
                ></i>
                Hmm. There was a problem marking this person as paid. Contact
                support@flocknote.com if the problem continues.
              </Error>
            ) : null}
          </AnimatePresence>
          <ButtonWrapper hasError={error}>
            <FnrButton3 size="small" onClick={handleClose}>
              {error ? "Close" : "No"}
            </FnrButton3>

            {!error ? (
              <FnrButton3
                size="small"
                color="green"
                onClick={markAsPaid}
                loading={loading}
              >
                Yes
              </FnrButton3>
            ) : null}
          </ButtonWrapper>
        </PopoverContent>
      </FnrPopoverWithScroll>
    </>
  );
}

const Pill = styled.div`
  background: ${(props) => (props.$hasUnpaidSlots ? "#ddb504" : "#a5a5a5")};
  padding-inline: 6px;
  padding-block: 1px;
  font-size: 9px;
  letter-spacing: 0.3px;
  font-weight: 600;
  color: rgb(255 255 255 / 90%);
  border-radius: 16px;
  text-transform: uppercase;

  &:hover {
    cursor: pointer;
  }
`;

const PopoverContent = styled(motion.div)`
  display: flex;
  flex-direction: column;
  padding: 6px;
  color: rgba(255, 255, 255, 0.9);
`;

const TheQuestion = styled.div``;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: ${(props) => (props.hasError ? "center" : "space-between")};
  gap: 8px;
`;

const Error = styled(motion.div)`
  border: 1px solid white;
  padding: 0.25rem;
  border-radius: 8px;
  margin-bottom: 10px;
  font-size: 14px;
`;